interface IProps {
  url: string;
}

export const BackgroundProfileImage: React.FC<IProps> = ({ url, children }) => (
  <div className="contact-profile-image" style={{ backgroundImage: `url(${url})` }}>
    {children}
  </div>
);
